// Single source of truth for the medication kind the funnel orders.
// med-users resolves it together with the subscription duration to a Telegra product
// variation. The funnel persists it on the signup-session as `medication_kind` via
// PATCH /signup-session (PaywallGlpCheckout); /auth/signup then sources it from there.
export type MedicationKindEnum = 'semaglutide' | 'tirzepatide'

// Narrowing boundary: turn an untyped value (a survey answer, a remote flag) into a
// valid MedicationKindEnum or undefined, so a stray string can never reach the backend
// `medication_kind` field or the paywall router undetected.
export function asMedicationKind(value: unknown): MedicationKindEnum | undefined {
	return value === 'semaglutide' || value === 'tirzepatide' ? value : undefined
}
